import { render } from "./CompareParties.vue?vue&type=template&id=2251c24e"
import script from "./CompareParties.vue?vue&type=script&lang=js"
export * from "./CompareParties.vue?vue&type=script&lang=js"

import exportComponent from "/Users/walleka/projektit/2022-02-aluevaalit-vaalikonevastaukset/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__